import { IDnDData } from './';
import { DnDTools } from './DnDTools';

export class DnDDataReader
    implements IDnDData {

    public typeName?: string;
    public value?: any;

    public read(dataTransfer: DataTransfer): void {
        if (!this.typeName || this.typeName.length === 0) { throw new Error('typeName is not set'); }

        const mimeType = DnDTools.getMimeType(this.typeName);
        let data;
        try {
            data = dataTransfer.getData(mimeType);
        } catch (ex) {
            if (typeof(ex.number) === 'number' && ex.number === -2147024809) {
                data = dataTransfer.getData(DnDTools.IE11MimeType);
            } else {
                throw ex;
            }
        }
        this.value = JSON.parse(data);
    }
}
